
import { Button } from "@/components/ui/button";
import { EventRecommendations, DateRecommendation } from "./types";

interface EventCardFooterProps {
  status: string;
  guests: any[] | undefined;
  archived: boolean;
  onArchiveToggle?: () => void;
  recommendations?: EventRecommendations;
  isHost?: boolean;
  onReviewClick?: () => void;
  event_date_recommendations?: DateRecommendation[];
}

export const EventCardFooter = ({
  archived,
  onArchiveToggle,
  status,
  isHost = false,
  onReviewClick,
  event_date_recommendations = []
}: EventCardFooterProps) => {
  // Show confirm details button when:
  // 1. There are date recommendations
  // 2. User is the host
  // 3. Event status is 'planned'
  const showReviewRecommendationsButton = event_date_recommendations.length > 0 && isHost && status === 'planned';
  
  if (!showReviewRecommendationsButton) {
    return null;
  }
  
  return (
    <div className="flex flex-col items-center gap-2">
      <Button 
        variant="default" 
        size="sm" 
        className="self-center px-3 py-1.5 text-white bg-black hover:bg-black/90 shadow-md rounded-lg mt-2" 
        onClick={e => {
          e.stopPropagation();
          onReviewClick?.();
        }}
      >
        Confirm Details
      </Button>
    </div>
  );
};

